module.exports = __webpack_public_path__ + "static/media/jeep-lwb-side.5f10ff50.webp";